import { render, staticRenderFns } from "./callWord.vue?vue&type=template&id=974f6056&scoped=true"
import script from "./callWord.vue?vue&type=script&lang=js"
export * from "./callWord.vue?vue&type=script&lang=js"
import style0 from "./callWord.vue?vue&type=style&index=0&id=974f6056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974f6056",
  null
  
)

export default component.exports